import styled from 'styled-components'
import PropTypes from 'prop-types'

import { PB } from '@h2/components/colors'

const Wrap = styled.div`
  display: flex;
  background-color: ${({ bgColor }) => bgColor};
  padding: 10px 135px;
  gap: 20px;
  min-height: 50px;
`
const FilterGrid = ({ bgColor = PB, children, ...rest }) => {
  return (
    <Wrap bgColor={bgColor} {...rest}>
      {children}
    </Wrap>
  )
}

FilterGrid.propTypes = {
  bgColor: PropTypes.string
}
export { FilterGrid }
